import { Icon } from '@chakra-ui/react';

export const ForwardCaretSvg = (): JSX.Element => (
  <Icon
    fill="none"
    h={6}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    w={6}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.36612 4.33474C7.85427 3.88842 8.64573 3.88842 9.13388 4.33474L16.6339 11.1919C17.122 11.6382 17.122 12.3618 16.6339 12.8081L9.13388 19.6653C8.64573 20.1116 7.85427 20.1116 7.36612 19.6653C6.87796 19.219 6.87796 18.4953 7.36612 18.049L13.9822 12L7.36612 5.95098C6.87796 5.50467 6.87796 4.78105 7.36612 4.33474Z"
      fill="black"
    />
  </Icon>
);
